import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";

import {TableCell, TableRow} from "@mui/material";

import StartDate from "./components/StartDate";
import EndDate from "./components/EndDate";
import VariationPercentage from "./components/VariationPercentage";
import ErrorCount from "./components/ErrorCount";
import Status from "./components/Status";
import ImportReportActions from "./components/ImportReportActions";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

ImportReportRow.propTypes = {
    importReport: PropTypes.object.isRequired,
    previousImportReport: PropTypes.object,
    retailerId: PropTypes.string,
    feedId: PropTypes.string,
};

function ImportReportRow({importReport, previousImportReport, ...props}) {
    const history = useHistory();

    function displayImportDetail(importReport) {
        const {retailerId, feedId} = props;
        const reportId = importReport['@id'].replace('/import_reports/', '');

        history.push({
            pathname: MarketplaceRoutes.RETAILER_FEEDS_HISTORY_IMPORT_REPORT(retailerId, feedId, reportId),
            type: "parent",
        });
    }

    function importReportVariationPercentage(importReport, previousImportReport) {
        if (
            previousImportReport === null
            || previousImportReport === undefined
            || importReport.variationReferenceCount === null
            || previousImportReport.variationReferenceCount === null
        ) {
            return 0;
        }

        return ((importReport.variationReferenceCount - previousImportReport.variationReferenceCount) / previousImportReport.variationReferenceCount) * 100;

    }

    const variationPercentage = importReportVariationPercentage(importReport, previousImportReport);

    return (
        <TableRow
            sx={{cursor: 'pointer'}}
            onClick={() => displayImportDetail(importReport)}
            hover
            tabIndex={-1}
            key={importReport['@id']}
        >
            <TableCell>
                <StartDate date={importReport.createdAt} />
            </TableCell>
            <TableCell>
                <EndDate date={importReport.endedAt} />
            </TableCell>
            <TableCell>
                <b>{importReport.variationReferenceCount}</b>
            </TableCell>
            <TableCell>
                <VariationPercentage value={variationPercentage}/>
            </TableCell>
            <TableCell>
                <ErrorCount count={importReport.nbErrors}/>
            </TableCell>
            <TableCell>
                <Status
                    errorCount={importReport.nbErrors}
                    variationPercentage={variationPercentage}
                    hasEnded={importReport.endedAt !== null}
                />
            </TableCell>
            <TableCell sx={{display: 'flex', justifyContent: 'end'}}>
                <ImportReportActions importReport={importReport} />
            </TableCell>
        </TableRow>
    );
}

export default ImportReportRow;
